import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-map",
  templateUrl: "./med-icon-map.component.html",
})
export class MedIconMapComponent extends SvgMixinComponent {}
